import React__default from 'react';
import styled from '@emotion/styled';
import { theme } from './miscTheme.js';

const StyledDivider = styled.hr `
  border-width: 1px;
  border-color: ${theme.colors.neutral200};
  border-style: ${(props) => props.dividerType};
`;

/**
 * @deprecated Consider to use mantine
 */
const Divider = ({ type = 'solid', className, style }) => {
    return (React__default.createElement(StyledDivider, { style: style, className: className, "data-diver-type": type, dividerType: type }));
};

export { Divider as D };
